import React, { useState } from 'react';
import Navbar from '../../components/common/Navbar';
import SignUpMain from './Main';
import SignUpVerification from './SignUpPassword';
import './style.css';
import FooterTrustChat from '../../components/common/FooterTrustChat';
import RegistrationComplete from './RegistrationComplete';

const registrationStates = [0, 1, 2];
const SliderRegistration = [0, 1];

export default function SignUp() {
  const [selectedState, setSelectedState] = useState(registrationStates[0]);
  const [sliderState, setSliderState] = useState(SliderRegistration[0]);
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');

  const handleBack = () => {
    setSelectedState(0);
    setSliderState(0);
    setPassword('');

    const passwordInputs = document.querySelectorAll('input[type="password"]');
    passwordInputs.forEach(input => {
      input.value = '';
      input.setAttribute('autocomplete', 'new-password');
    });
  };

  return (
    <div className='main-signup-container'>
      <Navbar />
      {selectedState === 0 && (
        <SignUpMain
          setEmail={setEmail}
          setFullName={setFullName}
          setSelectedState={setSelectedState}
          setSliderState={setSliderState}
          sliderState={sliderState}
          SliderRegistration={SliderRegistration}
          email={email}
          fullName={fullName}
        />
      )}
      {selectedState === 1 && (
        <SignUpVerification
          setPassword={setPassword}
          password={password}
          email={email}
          fullName={fullName}
          setSelectedState={setSelectedState}
          sliderState={sliderState}
          SliderRegistration={SliderRegistration}
          setSliderState={setSliderState}
          onBack={handleBack}
        />
      )}
      {selectedState === 2 && (
        <RegistrationComplete />
      )}
      <FooterTrustChat />
    </div>
  );
}
